import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";

import constants from '../../../constants';
import MoveTypeDropDown from "../../../uiControls/MoveTypeDropDown";
import {Search} from "../../../filtering";

import {NavigationType, openNewPage} from '../../../util/navigationHelpers';

import lockBlue from '../../../img/lock_blue.png';
import lockRed from '../../../img/lock_red.png';

import {
  DateRenderer,DateTimeRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faCalculator, faCopy, faFileAlt, faPencilAlt, faPlus, faTrashAlt, } from '@fortawesome/free-solid-svg-icons';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ApplicationContext from '../../../ApplicationContext';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import PrimaryButton from '../../../ui/PrimaryButton';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import {JobNames} from "../../../framework.core/JobNames";
import {OeMblListItem, OemListType} from "../../../fms.data/models/OeMblListItem";
import {oceanExportMblList} from "../tableSettings";
import IfmsModal from "../../../ui/IfmsModal";
import fastStorage from "../../../fastStorage";
import MblMilestonePopup from "./MblMilestonePopup";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import loadInfoAreaInvoiceBillCrDb from '../../common/InfoAreaInvoiceBillCrDb';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, LclFclFilterRenderer, LclFclRenderer, RecognizedFilterRenderer, RecognizedRenderer, ShipmentTypeFilterRenderer, ShipmentTypeRenderer, TrackEventNameRenderer } from '../../common/commonListRenderers';
import DeleteHistory from "../../reports/DeleteHistory";
import postal from 'postal';
import { getFmsGlobal } from '../../../globals';
import { FmsSecTask } from '../../../fms.core/constants';
import BlackInverseButton from '../../../ui/BlackInverseButton';
import carriersTrackingIcon from '../../../img/carriers-tracking.svg';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask } from '../../../util';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import _ from 'lodash';
import RecogModal from '../../../ui/RecogModal';
import useSetEditedId from '../../../hooks/useSetEditedId';
import { formatDateTime } from '../../../dateUtils';
import { formatShipmentType, formatLclFcl } from '../../common/utils/formatUtils';

// function ColoadFilterRenderer({value, onChange}: any) {
//   return (
//     <Select
//       value={value}
//       onChange={e => onChange(e.target.value)}
//       items={[
//         // { value: 'A', label: 'Agent'},
//         {value: '', label: 'None'},
//         {value: 'C', label: 'Consol'},
//         {value: '1', label: 'Co-Load'},
//         // { value: 'N', label: 'Direct(No HBL)'},
//       ]}
//     />
//   );
// }

function MoveTypeFilterRenderer({value, onChange}: any) {
  return (
    <MoveTypeDropDown
      name='ifms-filter-moveType-select'
      value={value}
      onChange={moveType => onChange(moveType)}      
    />
  );
}

// function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
//   return (
//     <div style={{height: '100%'}}>
//       <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
//         <CurrencyLabel currency={currency} value={value}/>
//       </div>
//     </div>
//   );
// }

// function IndicatorRenderer({value, data, row}: any) {
//   const jobListContext = useContext(JobListViewContext);
//   let content:React.ReactNode | null = null;

//   if(!value) {
//     content = <span>D</span>;
//   }else{
//     content = <span>{value}</span>; 
//   }

//   function onIndicatorClick() {
//     if (jobListContext.rowExtrasId) {
//       return; // Some row is already selected
//     }

//     jobListContext.setRowExtrasId(data[row.index].id);
//   }

//   return (
//     <div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
//   );
// }
function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="7px" src={lockBlue} id={'blueIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="Container Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

// function ColoadRenderer({cell}: any) {
//   if (cell && cell.value === '1') {
//     return <div className="ifms-table-default">
//       <CheckBoxIcon value={true} />
//     </div>;  
//   }

//   return null;
// }

// function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
//   const entity = data[row.index];

//   return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
//     <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
//             onClick={() => onLinkToAccounting(entity)}>{value}</button>
//     &nbsp;
//   </div>;
// }

function HblRenderer({data, row, value}: any) {
  const {switchToHblFor} = useMblOperations();

  if (data[row.index].direct) {
    return <div className="ifms-table-default">DBL</div>;
  }

  const isNumber = !isNaN(parseInt(value));

  if (!isNumber) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToHblFor(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useMblOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

// function CntrNoRenderer({value}: any) {
//   return <span className="input-control-row-label-link">{value}</span>
// }

function useMblOperations() {
  const history = useHistory();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const jobListContext = useContext(JobListViewContext);

  function switchToHblFor(mbl: OeMblListItem | null) {
    if (!mbl) {
      return;
    }

    // jobListContext.setFilterForScreenExternally('/common/joblistview/oeHbl/oceanExport', 'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false);
    jobListContext.setFilterForScreenExternally('/common/joblistview/oeHbl/oceanExport', 
    'oeMblId', 'Ref. #', mbl.id, 'updated', false, true, null, 'refNo', mbl.refNo, false,true);
    openNewPage(history, `/common/joblistview/oeHbl/oceanExport`, NavigationType.newPage);
  }
  
  async function switchToAcctInfo(mbl:OeMblListItem|null) {
    if (!mbl) {
      return;
    }
    
    openNewPage(history, `/accounting/Acct/${JobNames.OEMbl}/${mbl.id}`, NavigationType.newPage);
  }

  return {switchToHblFor, switchToAcctInfo};
}

function useSelectedMblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const {switchToHblFor} = useMblOperations();

  const selectedElement = jobListContext.selectedElement as OeMblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const channel = postal.channel('ajax');

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanExport/mbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    openNewPage(history, '/oceanExport/mbl/add', NavigationType.newPage);
  }

  async function deleteMbl() {
    if (!selectedElement) {
      return;
    }

    if ((selectedElement.hblCount !== 'DBL' && selectedElement.hblCount !== 'X' && selectedElement.hblCount !== '0')) {
      await showGlobalOkDialog('Need to delete HBL first.',false,null,'warning');
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close MBL first', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/OEMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/OEMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/OEMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/OEMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/OEMB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/OEMB/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.',false,null,'warning');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OEMbl, { id:selectedElement.id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl =`/oceanExport/mbl/edit/${id}`;
    const viewUrl = `/oceanExport/mbl/view/${id}`;
    
    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/oceanExport/mbl/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/oceanExport/viewBillings/mbl/${id}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToDeleteHistoryReport() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.OEMbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function viewProfit(viewEdit:boolean) {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/oceanExport/mbl/edit/${id}`;
    const viewUrl = `/oceanExport/mbl/view/${id}`;
    //let url = `/oceanExport/mbl/${viewEdit ? 'edit' : 'view'}/${id}`;
    
    let editUrlProfitTab = `${editUrl}/3`;
    let viewUrlProfitTab = `${viewUrl}/3`;

    if (viewEdit && jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/oceanExport/mbl/edit`, editUrl)) {
      await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
      return;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewEdit ? editUrlProfitTab : viewUrlProfitTab, [viewUrl, editUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl =`/oceanExport/mbl/edit/${id}`;
    const viewUrl = `/oceanExport/mbl/view/${id}`;
    const listSec = findSecurityTask(appContext, FmsSecTask.OEMbl);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanExport/mbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/oceanExport/mbl/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToHbl() {
    const selectedElement = jobListContext.selectedElement as OeMblListItem;
    if (selectedElement?.hblCount !== 'DBL') switchToHblFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return {create, deleteMbl, edit, view, copy, switchToHbl, recognize, viewBillings, moveToDeleteHistoryReport, viewProfit};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteMbl, edit, view, copy, switchToHbl, recognize, viewBillings, viewProfit } = useSelectedMblOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as any;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  
  const listSec = findSecurityTask(appContext, FmsSecTask.OEMbl);
  const fmsGlobal = getFmsGlobal();

  function openContainerStatus() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
  }

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.OEMbl, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult,false,null,'warning');
      return;
    }

    if (selectedElement.isClosed && jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/edit/${selectedElement.id}`)) {
      const editModelKey = `editOeMbl${selectedElement.id}-/oceanExport/mbl/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isFileClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
    }

    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock);
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to HBL List', shortcut: 'F6', separator: false, disabled : selectedElement?.hblCount === 'DBL' },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'Bilings', shortcut: 'F7', separator: !listSec?.grantEdit },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: !listSec?.grantEdit },
    { label: 'Container Status Update', shortcut: '', separator: false },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="oem-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));
  
  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteMbl();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        switchToHbl();
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        copy();
        break;
      case 8:
        viewBillings();
        break;
      case 9:
        viewProfit(listSec?.grantEdit ? true : false);
        break;
      case 10:
        openContainerStatus();
        break;
      case 11:
        processFileLock();
        break;
      case 12:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

// function AfterMemoLogButtonCommands() {
//   const jobListContext = useContext(JobListViewContext);
//   const selectedElement = jobListContext.selectedElement as OeMblListItem;

//   return (
//     <>
//       &nbsp;&nbsp;
//       <BlackInverseButton size='small' data-tooltip="Go to Carrier's Tracking"
//         onClick={() => window.open(`http://dotnet.freightstream.com/fsutil/customs.asp?mbn=${selectedElement?.mblNo}`)}>
//         <img height="24px" width='24px' src={carriersTrackingIcon} alt="Go to Carrier's Tracking" style={{ position: 'relative', top: '-1px' }} />
//       </BlackInverseButton>
//     </>
//   )
// }

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OeMblListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if (!suntekSettings.general?.allowViewJournalOP && !userId.startsWith('@')) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.OEMbl, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}

function MblListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  const selectedElement = jobListContext.selectedElement as OeMblListItem;

  const {deleteMbl, edit, view, copy, viewBillings, moveToDeleteHistoryReport} = useSelectedMblOperations();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const setSavedEntityAfterRecog = useSetEditedId([JobNames.OEHbl, JobNames.SlipJournal]);
  
  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/view/${id}`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityAfterRecog('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanExport/mbl/add`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.OEMbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }

  const allowedStatuses = ['', 'E', 'D'];
  
  const listSec = findSecurityTask(appContext, FmsSecTask.OEMbl);

  const hasSelectedRow = !!selectedElement;
  // const canBeDeleted = hasSelectedRow && !hasOpenedViewOrEditFor(selectedElement.id) && selectedElement.canBeDeleted
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;


  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name='oem-list-add-button' display="primary" size="regular" link="/oceanExport/mbl/add" disabled={!canBeAdd} label="New"/>&nbsp;
        <PrimaryButton name='oem-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='oem-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='oem-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteMbl}>Delete</PrimaryButton>&nbsp;
        <PrimaryButton name='oem-list-copy-button' size="regular" disabled={!canBeCopied} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <PrimaryButton name='oem-list-viewBillings-button' size="regular" onClick={viewBillings}>{constants.List_Billings}</PrimaryButton>&nbsp;
      <PrimaryButton name='oem-list-deleteHistory-button' size="regular" onClick={moveToDeleteHistoryReport}>Delete History</PrimaryButton>
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal noVerticalScroll isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.id} mTbName={"T_OOMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function MblListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function MblListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const listSec = findSecurityTask(appContext, FmsSecTask.OEMbl);

  const {copy, create, edit, view, switchToHbl, viewBillings, viewProfit} = useSelectedMblOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToHbl();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "CTRL+F2") {
      copy();
    } else if (unprocessedFkey === "F7") {
      viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      viewProfit(listSec?.grantEdit ? true : false);
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F4', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `MBL #: ${(jobListContext.selectedElement as OeMblListItem|null)?.mblNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.oceanExportMbl}
      jobName={JobNames.OEMbl}
      //entityId={(jobListContext.selectedElement as OeMblListItem | null)?.id}
      jobId={(jobListContext.selectedElement as OeMblListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
          params: { appContext, jobListContext, history, infoHeadline }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

/**
 * Concrete implementation for MBL List screen
 *
 * @class MblListView
 * @extends {AbstractListView}
 */
class MblListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.OEMbl,
      'OeMblListItem',
      OeMblListItem.calculateSearchParameters(search, OeMblListItem.MapOeSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat', 'lclFcl', 'moveType']),
      1,
      search.pageSize,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: OeMblListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      /*{
        accessor: 'ebl',
        renderer: CheckboxFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v ? 'true' : 'false',
      },
      {
        accessor: 'expressRelease',
        renderer: CheckboxFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v ? 'true' : 'false',
      },*/
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'lclFcl',
        renderer: LclFclFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'moveType',
        renderer: MoveTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'coload',
        renderer: undefined,
        searchValueExtractor: (v: any | null | undefined) => v === true ? '1' : '0',
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanExportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return [
      {accessor: 'status', Cell: IndicatorRenderer},
      {accessor: 'shipmentType', Cell: ShipmentTypeRenderer},
      {accessor: 'recognized', Cell: RecognizedRenderer},
      {accessor: 'invStat', Cell: BillingsRenderer},
      {accessor: 'billStat', Cell: BillingsRenderer},
      {accessor: 'crDbStat', Cell: BillingsRenderer},
      {accessor: 'coload', Cell: NullableCheckboxIconRenderer},
      {accessor: 'lclFcl', Cell: LclFclRenderer},
      {accessor: 'refNo', Cell: TextAlignLeftRenderer},
      {accessor: 'mblNo', Cell: TextAlignLeftRenderer},
      {accessor: 'hblCount', Cell: HblRenderer, Header: () => <span><u>HBL</u>(s)</span>},
      {accessor: 'branch', Cell: TextRenderer},
      {accessor: 'moveType', Cell: TextAlignLeftRenderer},
      {accessor: 'agentSName', Cell: TextAlignLeftRenderer},
      {accessor: 'agentRefNo', Cell: TextAlignLeftRenderer},
      {accessor: 'carrierSName', Cell: TextAlignLeftRenderer},
      {accessor: 'bookingNo', Cell: TextAlignLeftRenderer},
      {accessor: 'pLofRec', Cell: TextAlignLeftRenderer},
      {accessor: 'finalDest', Cell: TextAlignLeftRenderer},
      {accessor: 'bookCfrm', Cell: DateRenderer},
      {accessor: 'sedSent', Cell: DateRenderer},
      {accessor: 'dlvrToCarr', Cell: DateRenderer},
      // Don't know yet
      {accessor: 'cargoRelease', Cell: DateRenderer},

      {accessor: 'vessel', Cell: TextAlignLeftRenderer},
      {accessor: 'voyage', Cell: TextAlignLeftRenderer},
      {accessor: 'cutOffDate', Cell: DateRenderer},
      {accessor: 'loadingPort', Cell: TextAlignLeftRenderer},
      {accessor: 'etd', Cell: DateRenderer},
      {accessor: 'disCharge', Cell: TextAlignLeftRenderer},
      {accessor: 'eta', Cell: DateRenderer},
      // {accessor: 'deliveryPort', Cell: TextAlignLeftRenderer},
      // {accessor: 'feta', Cell: DateRenderer},
      {accessor: 'paidStatus', Cell: PaidRenderer},
      {accessor: 'paidDate', Cell: DateRenderer},
      {accessor: 'containerNo', Cell: TextAlignLeftRenderer},
      {accessor: 'conType', Cell: TextRenderer},
      {accessor: 'lotNo', Cell: TextAlignLeftRenderer},
      {accessor: 'svccNo', Cell: TextAlignLeftRenderer},
      {accessor: 'createdAt', Cell: DateTimeRenderer},
      {accessor: 'u2Date', Cell: DateTimeRenderer},
      {accessor: 'u2ID', Cell: TextAlignLeftRenderer},
      {accessor: 'u1ID', Cell: TextAlignLeftRenderer},
      {accessor: 'lastEvent', Cell: TrackEventNameRenderer}
    ];
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
    colRenderer.push({ accessor: 'lclFcl', changedValue: (value: any) => { return formatLclFcl(value['lclFcl']) } });
    colRenderer.push({ accessor: 'lastEvent', changedValue: (value: any) => { return (!!value['lastEvent'] ? value['lastEvent'] + ' ' + formatDateTime(value['lastEventDate']) : '') } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(opType: string, systemSettings: SystemSettings, suntekSettings: SuntekSettings): TableSettings {
    const tsettings = oceanExportMblList;
    const lType = this.suntekSettings?.oceanAir?.useLotNumber ? OemListType.UseLot : OemListType.Normal;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = OeMblListItem.getExportCollection(lType, useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }
  
  getTableDomIdSuffix(): string {
    return this.suntekSettings?.oceanAir?.useLotNumber ? 'uselotoem' : '';
  }

  renderCommands() {
    return (
      <MblListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <MblListToolbar/>
    );
  }

  renderExtras(hideLogHistory: boolean) {
    return <MblListViewExtras hideLogHistory={hideLogHistory} />
  }

  getViewUrlFor(row: OeMblListItem) {
    return row && row.id ? `/oceanExport/mbl/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'MBL List';
  };

  renderRowExtras(rowId: number | null, context: IJobListViewContext): React.ReactNode|null {
    if (!rowId) {
      return null;
    }

    function onClose() {
      const storageKey = `oe-mbl-milestone-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="Container Status Update" width="760px">
        <MblMilestonePopup mblId={rowId} storageKey={`oe-mbl-milestone-${rowId}`} onClose={onClose} isView={false} />
      </IfmsModal>
    );
  }

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.OEMbl} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  commandsAfterMemoLogBtn():React.ReactNode{
    //#1607
    // return <AfterMemoLogButtonCommands />
    return null;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }

  useLogHistory(): boolean {
    return true;
  }
}

export default MblListView;
